import { createIcon } from '@chakra-ui/react/icon'

const PointsIcon = createIcon({
  displayName: 'PointsIcon',
  viewBox: '0 0 15 15',
  path: [
    <path
      d="M2.13762 7.49996C2.13762 8.29194 1.67863 8.84392 1.18214 9.6539C0.28367 11.1179 -0.721301 12.8038 0.738157 14.2618C2.19761 15.7197 3.88207 14.7163 5.34602 13.8193C6.1575 13.3228 6.70798 12.8638 7.49996 12.8638C8.29194 12.8638 8.84392 13.3228 9.6539 13.8193C11.1179 14.7163 12.8023 15.7212 14.2618 14.2618C15.7212 12.8023 14.7163 11.1179 13.8193 9.6539C13.3228 8.84242 12.8638 8.29194 12.8638 7.49996C12.8638 6.70798 13.3228 6.156 13.8193 5.34602C14.7163 3.88207 15.7212 2.19761 14.2618 0.738157C12.8023 -0.721301 11.1179 0.28367 9.6539 1.18214C8.84242 1.68013 8.29194 2.13762 7.49996 2.13762C6.70798 2.13762 6.156 1.67863 5.34602 1.18214C3.88207 0.28367 2.19611 -0.721301 0.738157 0.738157C-0.719801 2.19761 0.28367 3.88207 1.18214 5.34602C1.67863 6.156 2.13762 6.70798 2.13762 7.49996Z"
      fill="white"
      key="PointsIcon"
    />,
  ],
})

export default PointsIcon
